import { Box, Grid, Typography } from "@mui/material";

interface StatBoxProps {
  value?: number;
  label?: string;
  color?: string;
  borderRight?: boolean;
  examMode?: boolean;
  children?: React.ReactNode;
  fullWidth?: boolean;
}

export default function StatBox({
  value,
  label,
  color = "#3b3e66",
  borderRight = false,
  examMode = false,
  children = null,
  fullWidth = false,
}: StatBoxProps) {
  return (
    <Grid
      item
      xs={fullWidth ? 12 : 3}
      sm={examMode ? 2 : 3}
      sx={
        borderRight
          ? { borderRight: "1px solid #ddd", borderTop: "1px solid #ddd" }
          : { borderTop: "1px solid #ddd" }
      }
    >
      <Box py={2} textAlign="center">
        {children ? (
          children
        ) : (
          <>
            {" "}
            <Typography
              fontSize={20}
              fontWeight={500}
              color={color}
              sx={{ lineHeight: 1 }}
            >
              {value}
            </Typography>
            <Typography fontSize={14} color="#3b3e66">
              {label}
            </Typography>
          </>
        )}
      </Box>
    </Grid>
  );
}
